import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=4a88954e&scoped=true&"
var script = {}
import style0 from "./Privacy.vue?vue&type=style&index=0&id=4a88954e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a88954e",
  null
  
)

export default component.exports